import React, {useCallback, useContext, useRef, useState} from "react"
import Menu, {MenuItem} from "@amzn/meridian/menu";
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon";
import menuTokens from "@amzn/meridian-tokens/base/icon/menu-meatball";
import {RouteStageContext} from "../stageStatus/context/RouteStageContext";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, CORE_AMZL} from "../util/Constants";

const CartContextMenu = (props) => {
    const iconRef = useRef()
    const [open, setOpen] = useState(false)
    const onClickButton = useCallback(() => setOpen(true), [])
    const onClose = useCallback(() => setOpen(false), [])
    const {dispatch} = useContext(RouteStageContext)
    const {configViewModel} = useContext(CapabilityContext)

    const sideLineRoute = () => {
        dispatch({
            type: 'SIDELINE_ROUTE',
            data: {
                dispatcher: dispatch,
                routeId: props.cart.routeId,
                stationCode: props.cart.stationCode,
                baseUrl: configViewModel.baseUrl,
                stationConfig: configViewModel.stationConfig
            }
        });
    }

    const unassignStager = () => {
        dispatch({
            type: 'UNASSIGN_STAGER',
            data: {
                dispatcher: dispatch,
                stageListId: props.cart.stageListId,
                stationCode: props.cart.stationCode,
                associateId: props.cart.associateId,
                baseUrl: configViewModel.baseUrl,
                stationConfig: configViewModel.stationConfig
            }
        });
    }

    return (
        <React.Fragment>
            <Button type="icon" ref={iconRef} onClick={onClickButton} size="small">
                <Icon tokens={menuTokens}>Settings</Icon>
            </Button>

            {/*AMZL Context Menu*/}
            {configViewModel.capability !== CORE_AMZL || props.cart.status === 'Sidelined' ? null :
                <Menu anchorNode={iconRef.current}
                      open={open}
                      position="right"
                      onClose={onClose}>
                    <MenuItem onClick={() => sideLineRoute()}>
                        <FormattedMessage id="cartMenu.sideline" defaultMessage="Sideline"/>
                    </MenuItem>
                </Menu>
            }

            {/*ARV2 Context Menu*/}
            {configViewModel.capability === AR_V2
            && props.cart.status === 'Ready'
            && props.cart.stageListId ?
                <Menu anchorNode={iconRef.current}
                      open={open}
                      position="right"
                      onClose={onClose}>
                    <MenuItem onClick={() => unassignStager()}>
                        <FormattedMessage id="cartMenu.unassign" defaultMessage="Unassign"/>
                    </MenuItem>
                </Menu>
                : null
            }
        </React.Fragment>
    )
}

export default CartContextMenu


// WEBPACK FOOTER //
// ./src/components/routeStageStatus/CartContextMenu.js